module.exports = __webpack_public_path__ + "fonts/close_svgrepo.com.svg";